import { render, staticRenderFns } from "./UsuarioPassword.vue?vue&type=template&id=243c344d&"
import script from "./UsuarioPassword.vue?vue&type=script&lang=js&"
export * from "./UsuarioPassword.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports